import { removeIndexFromArray } from "./auth-service-tools654.js";

function removeItemFromArray(array, item) {
  var index = array.indexOf(item);
  return removeIndexFromArray(array, index);
}

export { removeItemFromArray };